import { render, staticRenderFns } from "./EventTotalsContainer.vue?vue&type=template&id=54da1f92&scoped=true&"
import script from "./EventTotalsContainer.vue?vue&type=script&lang=js&"
export * from "./EventTotalsContainer.vue?vue&type=script&lang=js&"
import style0 from "./EventTotalsContainer.vue?vue&type=style&index=0&id=54da1f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54da1f92",
  null
  
)

export default component.exports